import React, { Component } from "react"
import { Table, Row } from "antd"
import Moment from "moment"
import { observer, inject } from "mobx-react"
import MaterialTip from "app/components/normal/MaterialTip/MaterialTip"
import WarningTip from "app/components/normal/WarningTip/WarningTip"
import Highlighter from "app/components/normal/HighLighter"
import highlightable from "app/utils/highlightable"
import folderIcon from "app/styles/images/sp/folder.svg"

const ObserverFamilyName = observer(({ record, _this, store }) => {
  const { editedHistory } = _this.state
  const { queryMap: { keywords } } = store
  const tip = (
    <MaterialTip
      overlayClassName="ellipsis-tip"
      title={record.name}
    >
      <Highlighter
        highlightClassName="lightlight"
        highlightStyle={{ fontWeight: "normal" }}
        searchWords={highlightable(record.name, keywords) ? [record.name] : []}
        textToHighlight={record.name}
      />
    </MaterialTip>
  )

  return (
    record.hasHistory
      ? (
        <Row
          onClick={() => _this.openDetail(record)}
          className="family-name cursor-p"
          type="flex"
          justify="start"
          align="middle"
        >
          <img className="folder-icon" src={folderIcon} alt="" />
          <WarningTip
            type="warningTip"
            text={tip}
            justify="start"
            mainKeys={["versionNum", "name", "createTime"]}
            historyData={editedHistory}
            onVisibleChange={(visible) => _this.toggleHistory(visible, record)}
          />
        </Row>
      )
      : (
        <div className="cursor-p" onClick={() => _this.openDetail(record)}>
          <img className="folder-icon" src={folderIcon} alt="" />
          <Highlighter
            highlightClassName="lightlight"
            highlightStyle={{ fontWeight: "normal" }}
            searchWords={highlightable(record.name, keywords) ? [record.name] : []}
            textToHighlight={record.name}
          />
        </div>
      )
  )
})

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      showDeleteModal: false,
      dataSingle: {},
      editedHistory: []
    }

    this.columns = []
  }

  componentDidMount() {
    let { store: { getTableData, updateDataListData, initPageIndex } } = this.props
    getTableData()
      .then(
        res => {
          updateDataListData(res)
          initPageIndex()
        }
      )
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        getTableData,
        updateDataListData,
        updateQueryMap,
        queryMap
      },
      store
    } = this.props

    store.currentPageIndex = selectedPageNumber
    updateQueryMap({ offset: (selectedPageNumber - 1) * queryMap.limit })
    getTableData(queryMap)
      .then(
        res => {
          updateDataListData(res)
        }
      )
    document.getElementById("contentTop").scrollIntoView(true)
  }

  toggleHistory = (visible, record) => {
    if (visible) {
      // 获取数据
      const { getDataHistory } = this.props.store
      getDataHistory(record.id)
        .then(res => {
          this.setState({
            editedHistory: res
          })
        })
    } else {
      //清空拿到的数据
      this.setState({
        editedHistory: []
      })
    }
  }

  openDetail = (record) => {
    const { match, history } = this.props
    history.push(`${match.url}/${record.id}`)
  }

  render() {
    let {
      store: {
        tableData,
        totalCount,
        queryMap,
        currentPageIndex,
        selectedRecycle,
      },
    } = this.props
    const { editedHistory } = this.state

    this.columns = [
      {
        title: (
          <div className="ta-l">家系名称</div>
        ),
        dataIndex: "name",
        render: (title, record, index) => {
          return (
            <ObserverFamilyName
              record={record}
              store={this.props.store}
              editedHistory={editedHistory}
              _this={this}
            />
          )
        }
      }, {
        title: (
          <div className="ta-c">数据数量</div>
        ),
        dataIndex: "dataCount",
        render: (text, record) => {
          return (
            <div className="ta-c">{text}条</div>
          )
        }
      }, {
        title: (
          <div className="ta-r">合计数据大小</div>
        ),
        dataIndex: "dataSize",
        render: text => {
          return text ? <div className="ta-r">{(text / 1024 / 1024).toFixed(2)}MB</div> : ""
        }
      }, {
        title: (
          <div className="ta-c time-title">上传时间</div>
        ),
        dataIndex: "createTime",
        render: text => {
          return text ? <div className="ta-c">{Moment(text).format("YYYY-MM-DD HH:mm:ss")}</div> : ""
        }
      }
    ]

    return (
      <div>
        <div
          className="wrapper-box"
          style={
            selectedRecycle === "data"
              ? {
                marginTop: 120
              }
              : {
                marginTop: 170
              }
          }
        >
          <Table
            className="recycle-data-table"
            columns={this.columns}
            rowKey={record => record.id + "store"}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          />
        </div>
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/recycleBin/containers/DataList.js